module.exports = __webpack_public_path__ + "static/img/bg58.aa9dab25.png";